import { createContext, useContext, useState } from "react";
import { api } from "@/lib/api";

const MembershipContext = createContext(null);
const KEY = "pm_member";

export function MembershipProvider({ children }) {
  const [member, setMember] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
  });

  const persist = (m) => {
    setMember(m);
    if (m) localStorage.setItem(KEY, JSON.stringify(m));
    else localStorage.removeItem(KEY);
  };

  const register = async ({ name, phone, email }) => {
    const { data } = await api.post("/members", { name, phone, email, opt_in: true });
    const m = { id: data.id, name: data.name, phone: data.phone, email: data.email, discount_pct: data.discount_pct, discount_used: data.discount_used };
    persist(m);
    return m;
  };

  // discount available if registered and not yet used
  const discountPct = member && !member.discount_used ? Number(member.discount_pct || 5) : 0;

  const markUsed = () => { if (member) persist({ ...member, discount_used: true }); };

  return (
    <MembershipContext.Provider value={{ member, register, discountPct, markUsed, clear: () => persist(null) }}>
      {children}
    </MembershipContext.Provider>
  );
}

export const useMembership = () => useContext(MembershipContext);
